import React from "react";
import { Form, FormGroup, Button, Label, Input } from "reactstrap";
import { withRouter } from "react-router-dom";
import ReactFilestack from "filestack-react";
import axios from "axios";

const API_KEY = "AGPirPvMfTs2BMOi8EPmaz";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3030";

class Signup extends React.Component {
  constructor() {
    super();
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      username: "",
      password: "",
      profile_picture: ""
    };
    this.handleChangeFirstName = this.handleChangeFirstName.bind(this);
    this.handleChangeLastName = this.handleChangeLastName.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangeUserName = this.handleChangeUserName.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  handleUpload(response) {
    if (response.filesUploaded[0].url) {
      this.setState({
        profile_picture: response.filesUploaded[0].url
      });
    }
    console.log(this.state.profile_picture);
  }

  handleChangeFirstName(event) {
    let value = event.target.value;
    this.setState(() => {
      return { firstName: value };
    });
  }

  handleChangeLastName(event) {
    let value = event.target.value;
    this.setState(() => {
      return { lastName: value };
    });
  }

  handleChangeEmail(event) {
    let value = event.target.value;
    this.setState(() => {
      return { email: value };
    });
  }

  handleChangeUserName(event) {
    let value = event.target.value;
    this.setState(() => {
      return { username: value };
    });
  }

  handleChangePassword(event) {
    const value = event.target.value;
    this.setState(() => {
      return { password: value };
    });
  }

  // submitForm(event) {
  //   event.preventDefault();
  // }

  async submitForm(event) {
    event.preventDefault();
    await axios
      .post(`${API_URL}/accounts`, {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        username: this.state.username,
        password: this.state.password,
        profile_picture: this.state.profile_picture
      })
      .then(res => {
        console.log(res);
        this.props.history.push("/signin");
      })
      .catch(error => {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        <div className="center">
          <h1>SIGN UP to FoodBook</h1>
        </div>

        <div>
          <div className="center">
            <div className="Container width-350">
              <Form onSubmit={this.submitForm}>
                <FormGroup>
                  <Label htmlFor="fname">First Name</Label>
                  <Input
                    type="text"
                    id="fname"
                    name="firstName"
                    placeholder="Your name.."
                    value={this.state.firstName}
                    onChange={this.handleChangeFirstName}
                  />
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="lname">Last Name</Label>
                  <Input
                    type="text"
                    id="lname"
                    name="lastName"
                    placeholder="Your last name.."
                    value={this.state.lastName}
                    onChange={this.handleChangeLastName}
                  />
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="email">Email</Label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Your email.."
                    value={this.state.email}
                    onChange={this.handleChangeEmail}
                  />
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="username">Username</Label>
                  <Input
                    type="text"
                    id="username"
                    name="username"
                    placeholder="Your username.."
                    value={this.state.username}
                    onChange={this.handleChangeUserName}
                  />
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="password">Password</Label>
                  <Input
                    type="password"
                    id="password"
                    name="password"
                    placeholder="Your password.."
                    value={this.state.password}
                    onChange={this.handleChangePassword}
                  />
                </FormGroup>

                <ReactFilestack
                  apikey={API_KEY}
                  onSuccess={response => this.handleUpload(response)}
                  render={({ onPick }) => (
                    <FormGroup row className="float-right">
                      <Button outline color="danger" size="sm" onClick={onPick}>
                        Upload Your Photo
                      </Button>
                    </FormGroup>
                  )}
                />

                <Button
                  outline
                  color="danger"
                  size="lg"
                  block
                  onClick={this.submitForm}
                >
                  Sign Up
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Signup);



// WEBPACK FOOTER //
// ./src/page/Signup.jsx